import Css from "./style.module.scss";

import * as Icons from "@phosphor-icons/react";
import AutoTooltip from "nlib/ui/AutoTooltip";
import Constants from "const/Constants";
import DataStatuses from "const/DataStatuses";
import DocumentRecogniseStatuses from "const/DocumentRecogniseStatuses";
import React from "react";

const DocumentIdCell = ({ documentData }) => {
  const {
    originalDocumentId,
    status,
    duplicatedDocumentsIds,
    recogniseData: { status: recogniseStatus } = {}
  } = documentData;

  const extractionStatus = status === DataStatuses.TO_EXTRACT;

  const hasDuplicates = !!(Array.isArray(duplicatedDocumentsIds) && duplicatedDocumentsIds.length);

  return (
    <div className={Css.documentIdCell}>
      <AutoTooltip className={Css.documentId} active={!!originalDocumentId}>
        {extractionStatus
          ? Constants.EMPTY_PLACEHOLDER
          : (
            <>
              {hasDuplicates
                ? <Icons.Copy className={Css.warning} />
                : <Icons.FileText className={recogniseStatus === DocumentRecogniseStatuses.ERROR ? Css.negative : ""} />}
              <span>{originalDocumentId || Constants.EMPTY_PLACEHOLDER}</span>
            </>
          )}
      </AutoTooltip>
    </div>
  );
};

export default React.memo(DocumentIdCell);
